import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject } from '@angular/core';
import { ConfirmService } from './confirm.service';

// Mounted once in app.html — every page calls ConfirmService.confirm() instead of reaching for
// window.confirm(), so there's exactly one dialog element/instance for the whole app.
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal fade" id="sharedConfirmModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body confirm-dialog-body">
            <div class="confirm-dialog-icon" [class.danger]="confirmService.options().danger">
              <i
                class="fa"
                [ngClass]="confirmService.options().icon || (confirmService.options().danger ? 'fa-trash-alt' : 'fa-question')"
              ></i>
            </div>
            <h5 class="confirm-dialog-title">
              {{ confirmService.options().title || (confirmService.options().danger ? 'Are you sure?' : 'Please confirm') }}
            </h5>
            <p class="confirm-dialog-message">{{ confirmService.options().message }}</p>
          </div>
          <div class="modal-footer confirm-dialog-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="confirmService.resolve(false)">
              {{ confirmService.options().cancelText }}
            </button>
            <button
              type="button"
              class="btn"
              [class.btn-danger]="confirmService.options().danger"
              [class.btn-primary]="!confirmService.options().danger"
              data-bs-dismiss="modal"
              (click)="confirmService.resolve(true)"
            >
              <i
                class="fa mr-1"
                [ngClass]="confirmService.options().icon || (confirmService.options().danger ? 'fa-trash-alt' : 'fa-check')"
              ></i>
              {{ confirmService.options().confirmText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .confirm-dialog-body {
        text-align: center;
        padding: 2rem 1.75rem 1.25rem;
      }

      .confirm-dialog-icon {
        width: 56px;
        height: 56px;
        margin: 0 auto 1rem;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5rem;
        color: #ffffff;
        background: linear-gradient(135deg, #3f6ad8 0%, #2c4ea3 100%);
        box-shadow: 0 8px 18px rgba(63, 106, 216, 0.35);

        &.danger {
          background: linear-gradient(135deg, #ef4757 0%, #c9202f 100%);
          box-shadow: 0 8px 18px rgba(239, 71, 87, 0.35);
        }
      }

      .confirm-dialog-title {
        font-weight: 800;
        margin-bottom: 6px;
      }

      .confirm-dialog-message {
        color: #6c7686;
        margin-bottom: 0;
      }

      .confirm-dialog-footer {
        justify-content: center;
        gap: 8px;

        .btn {
          min-width: 110px;
        }
      }
    `,
  ],
})
export class ConfirmDialogComponent implements AfterViewInit {
  confirmService = inject(ConfirmService);

  ngAfterViewInit() {
    // Escape / backdrop-click dismissal doesn't run either button's (click) handler — resolve()
    // is a no-op if a button already resolved it, so this is just the fallback for "closed any
    // other way", always treated as a cancel.
    const el = document.getElementById('sharedConfirmModal');
    el?.addEventListener('hidden.bs.modal', () => this.confirmService.resolve(false));
  }
}
